/**
 * DWG 정리 화면의 체크 상태 계산 — 체크 = 남길 레이어.
 */

import type { DwgLayer } from '../../../services/DwgCleanService'

export type DwgLayerFilter = 'all' | 'keep' | 'delete'

/** 처음 체크 상태: 서버 키워드 추천 + 지울 수 없는 레이어. */
export function initialKeep(layers: readonly DwgLayer[]): Set<string> {
  return new Set(layers.filter((l) => l.keep || l.locked).map((l) => l.name))
}

/** 체크가 풀린(지울) 레이어 이름. 지울 수 없는 레이어는 체크와 무관하게 빼고 보낸다. */
export function deleteNamesOf(layers: readonly DwgLayer[], keep: ReadonlySet<string>): string[] {
  return layers.filter((l) => !l.locked && !keep.has(l.name)).map((l) => l.name)
}

/** 이름·문자 예시 검색(대소문자 무시) + 남김/삭제 필터. */
export function filterLayers(
  layers: readonly DwgLayer[],
  keep: ReadonlySet<string>,
  query: string,
  filter: DwgLayerFilter,
): DwgLayer[] {
  const q = query.trim().toLowerCase()
  return layers.filter((l) => {
    if (filter === 'keep' && !keep.has(l.name)) return false
    if (filter === 'delete' && keep.has(l.name)) return false
    if (!q) return true
    return l.name.toLowerCase().includes(q) || (l.sampleText ?? '').toLowerCase().includes(q)
  })
}

/** 레이어 하나 토글. 지울 수 없는 레이어는 그대로. */
export function toggleKeep(keep: ReadonlySet<string>, layer: DwgLayer): Set<string> {
  const next = new Set(keep)
  if (layer.locked) return next
  if (next.has(layer.name)) next.delete(layer.name)
  else next.add(layer.name)
  return next
}

/** 보이는 레이어를 한꺼번에 남김(true)/삭제(false). 검색으로 좁힌 뒤 일괄 처리할 때 쓴다. */
export function setKeepAll(keep: ReadonlySet<string>, visible: readonly DwgLayer[], value: boolean): Set<string> {
  const next = new Set(keep)
  for (const l of visible) {
    if (l.locked) continue
    if (value) next.add(l.name)
    else next.delete(l.name)
  }
  return next
}
